import React, { Component } from 'react';
import '../css/LogoWall.css';

/*
 * Customer & partner marks, white on the Deep Gray ground (VI). Every file in
 * /logo/wall/ is a white-on-transparent version of the partner's own mark.
 * Anvil Robotics ships only an icon, so its entry is a lockup: icon + name.
 */
const LOGOS = [
  { name: 'Acer Synergy Tech', src: '/logo/wall/acer.svg', w: 132 },
  { name: 'CBM', src: '/logo/wall/cbm.svg', w: 112 },
  { name: '中興電工 CHEM', src: '/logo/wall/chem.png', w: 150 },
  { name: '嘟嘟房 dodohome', src: '/logo/wall/dodohome.png', w: 62 },
  { name: 'Ingensys', src: '/logo/wall/ingensys.svg', w: 150 },
  { name: '中華電信 Chunghwa Telecom', src: '/logo/wall/chunghwa.svg', w: 160 },
  { name: 'NVIDIA', src: '/logo/wall/nvidia.svg', w: 140 },
  { name: 'Universal Robots', src: '/logo/wall/ur.png', w: 150 },
  { name: 'NexCOBOT (NEXCOM Robotic Solutions)', src: '/logo/wall/nexcobot.png', w: 150 },
  { name: 'Anvil Robotics', src: '/logo/wall/anvil.svg', w: 30, lockup: 'Anvil Robotics' }
];

const sectionTitle = {
  zh: '值得信賴的合作夥伴',
  en: 'Trusted by leading companies',
  ja: '信頼されるパートナー'
};

function Mark({ logo, keyPrefix }) {
  // `w` is the mark's design width in px at desktop (scaled by --mark-scale);
  // height follows the file's own proportions, capped by --mark-max-h.
  const style = { '--mark-w': logo.w + 'px' };
  if (logo.lockup) {
    return (
      <span className="logowall-mark logowall-lockup" style={style}>
        <img src={logo.src} alt="" />
        <span className="logowall-lockup-name" aria-hidden="true">{logo.lockup}</span>
        <span className="sr-only">{logo.name}</span>
      </span>
    );
  }
  return (
    <span className="logowall-mark" style={style}>
      <img src={logo.src} alt={logo.name} loading="lazy" />
    </span>
  );
}

class LogoWall extends Component {
  render() {
    const lang = this.props.lang || 'en';

    if (this.props.mode === 'grid') {
      return (
        <div className="logowall-grid" role="list" aria-label={sectionTitle[lang]}>
          {LOGOS.map((logo) => (
            <div className="logowall-cell" role="listitem" key={logo.name}>
              <Mark logo={logo} />
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="logowall-section">
        <h2 className="logowall-title">{sectionTitle[lang]}</h2>
        <div className="marquee" aria-label={sectionTitle[lang]}>
          <div className="marquee__group">
            {LOGOS.map((logo) => <Mark logo={logo} key={logo.name} />)}
          </div>
          <div className="marquee__group" aria-hidden="true">
            {LOGOS.map((logo) => <Mark logo={logo} key={'d' + logo.name} />)}
          </div>
        </div>
      </div>
    );
  }
}

export default LogoWall;
